import React from "react";

const magentoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
    preserveAspectRatio="xMidYMid"
  >
    <g>
      <circle
        fill="#27140D"
        cx="129.141137"
        cy="127.998295"
        r="121.376367"
      ></circle>
      <path
        d="M129.141137,12.5712611 C145.140924,12.5712611 159.997869,15.9997869 173.711972,21.7139965 C187.426075,27.4282061 199.997336,35.4280995 210.282913,46.8565187 C220.568491,57.142096 229.711226,69.7133571 235.425436,83.4274602 C241.139645,97.1415632 244.568171,113.14135 244.568171,127.998295 C244.568171,142.85524 241.139645,158.855027 235.425436,172.56913 C229.711226,186.283233 221.711333,198.854494 210.282913,209.140071 C199.997336,219.425649 187.426075,228.568384 173.711972,234.282594 C159.997869,239.996803 143.998082,243.425329 129.141137,243.425329 C114.284192,243.425329 98.2844051,239.996803 84.5703021,234.282594 C70.8561991,228.568384 58.2849379,220.568491 47.9993606,209.140071 C37.7137834,198.854494 28.571048,186.283233 22.8568384,172.56913 C17.1426288,158.855027 13.714103,142.85524 13.714103,127.998295 C13.714103,113.14135 17.1426288,97.1415632 22.8568384,83.4274602 C28.571048,69.7133571 36.5709414,57.142096 47.9993606,46.8565187 C58.2849379,36.5709414 70.8561991,27.4282061 84.5703021,21.7139965 C98.2844051,15.9997869 113.14135,12.5712611 129.141137,12.5712611 M129.141137,0 C58.2849379,0 0,57.142096 0,127.998295 C0,198.854494 57.142096,255.99659 127.998295,255.99659 C198.854494,255.99659 255.99659,198.854494 255.99659,127.998295 C255.99659,57.142096 199.997336,0 129.141137,0 L129.141137,0 Z"
        fill="#F26724"
      ></path>
      <path
        d="M139.426714,98.2844051 L159.997869,109.712824 L159.997869,194.283126 L129.141137,211.425755 L98.2844051,194.283126 L98.2844051,109.712824 L118.85556,98.2844051 L118.85556,181.711865 L129.141137,187.426075 L139.426714,181.711865 L139.426714,98.2844051 Z M129.141137,44.5708349 L202.28302,85.713144 L202.28302,170.283446 L181.711865,181.711865 L181.711865,98.2844051 L129.141137,68.5705152 L76.5704087,98.2844051 L76.5704087,181.711865 L55.9992541,169.140604 L55.9992541,85.713144 L129.141137,44.5708349 Z"
        fill="#FDDFDD"
      ></path>
    </g>
  </svg>
);

export default {
  name: "magento2",
  color: "rgb(227, 74, 27)",
  icon: magentoIcon,
};
